/* eslint-disable no-unused-vars */
import axios from 'axios';
import moment from 'moment';
import { apiServerUrl } from '../../config/config.json';

const url = `${apiServerUrl}/documents`;

const state = {
    documents: [],
    initiated_documents: [],
    output_documents: [],
    output_activities: [],
    route_pending_documents: [],
    route_rejected_documents: [],
    documents_count: null,
    document_version_history: [],
    loading: false,
};

const getters = {
    allDocuments: state => state.documents,
    allInitiatedDocuments: state => state.initiated_documents,
    allOutputDocuments: state => state.output_documents,
    allOutputDocumentActivity: state => state.output_activities,
    allRoutePendingDocuments: state => state.route_pending_documents,
    allRejectedDocuments: state => state.route_rejected_documents,
    totalDocumentsCount: state => state.documents_count,
    documentHistory: state => state.document_version_history
};

const actions = {
    async fetchFilteredDocuments({commit},payload){
        commit('set_loading',true)
        commit('setDocuments',true)
        try {
            
            const search_value = `%${payload.search}%`
            const categories = payload.category.length > 0 ? payload.category : []
            const types = payload.type.length > 0 ? payload.type : []
            const start_date =  moment(payload.dateRange.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss")
            const end_date =  moment(payload.dateRange.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss")      

            
            const query = {
                "$document.createdAt$": {"$between": [start_date,end_date]},
                "$document.document_category_id$": {"$or": categories},
                "$document.document_type_id$": {"$or": types},
                "$and": {
                    "$or":[
                        {"$document.transaction_id$":{"$like":search_value}},
                        {"$document.subject$":{"$like":search_value}},
                        {"$document.sender$":{"$like":search_value}}
                    ]}
            }
            const q = encodeURIComponent(JSON.stringify(query,null,4));
            const customUrl = url + '?limit=' + payload.itemsPerPage + '&query='+ q ;
            
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(customUrl, {
                headers: { 'x-drmms-token': authToken }
            });
            
            response.data.rows = response.data.rows.filter(data => data.sender)
            let documents = {
                count: response.data.count,
                rows: response.data.rows.map((document) => ({
                ...document,
                    date: moment(document.createdAt).format('LLL'),
                }))
            }
            commit('set_loading',false)
            commit('setDocuments', documents);
        }
        catch(err){
            commit('set_loading',false)
        }
    },
    async fetchDocuments({ commit }, filter) {
        try {
            const { itemsPerPage  } = filter;
            const customUrl = url + '?limit=' + itemsPerPage ;
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(customUrl, {
                headers: { 'x-drmms-token': authToken }
            });
            response.data.rows = response.data.rows.filter(data => data.sender)
            let documents = {
                count: response.data.count,
                rows: response.data.rows.map((document) => ({
                ...document,
                    date: moment(document.createdAt).format('LLL'),
                }))

            }
            commit('setDocuments', documents);
        } catch (err) {
            console.log(err);
        }
    },
    async fetchInitiatedDocuments({ commit }) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(`${url}/initiated`, {
                headers: { 'x-drmms-token': authToken }
            });

            let documents = response.data.map((document) => ({
                ...document,
                date: moment(document.createdAt).format('LLL')
            }));
            commit('setInitiatedDocuments', documents);
        } catch (err) {
            console.log(err);
        }
    },
    async updateDocument({ commit }, data) {
        console.log(data)
        let body = data.body
        let supporting_documents = data.supp_docs
        try{
            const authToken = localStorage.getItem('access_token');
           
            const response = await axios({
                method: 'put',
                url: `${url}/${body.id}`,
                headers: { 'x-drmms-token': authToken },
                data: {
                    body
                }
            })
            let updatedDocument = Object.assign(response.data, {
                date: moment(response.data.createdAt).format('LLL'),
                document_type: body.document_type,
				document_category: body.document_category,
                supporting_documents
            });
            
            commit('updateDocument', updatedDocument);
            return true
        }catch(err){
            console.log(err);
            if (err.response) {
                if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                else if (err.response.status == 500) return { error: true, status: 500, message: 'Internal Server Error' };
            }
        }
    },
    
    async createSupportingDocument({commit}, body){
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.post(`${url}/supporting_documents`, body, {
                headers: { 'x-drmms-token': authToken}
            })
            commit('addSupportingDocumentToArray', response.data)
            return response.data
        } catch (err) {
            console.log(err)
            if (err.response) {
                if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                else if (err.response.status == 500) return { error: true, status: 500, message: 'Internal Server Error' };
            }
        }
    },
    async createDocument({ commit }, body) {
        
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.post(url, body, {
                headers: { 'x-drmms-token': authToken }
            });

            let newDocument = Object.assign(response.data, {
                date: moment(response.data.createdAt).format('LLL'),
                document_type: body.document_type,
				document_category: body.document_category,
                supporting_documents: []
            });

            commit('newDocument', newDocument);
            return newDocument
        } catch (err) {
            console.log(err);
            if (err.response) {
                if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                else if (err.response.status == 500) return { error: true, status: 500, message: 'Internal Server Error' };
            }
        }
    },
    async addInitiatedFromRoute({ commit }, body) {
        let ids = [];
        body.forEach(element => ids.push(element.id));
        commit('addInitDocumentsFromRoute', ids);
    },
    async fetchOutputDocuments({ commit }, body) {

        const { route_id, initiator_id, route_type } = body;

        const q = encodeURIComponent(JSON.stringify({ initiator_id, route_type }));
        const query = `?query=${q}`;

        try {

            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(`${url}/output/list/${route_id}${query}`, body, {
                headers: { 'x-drmms-token': authToken }
            });

            commit('setOutputDocuments', response.data);


        } catch (err) {
            console.log(err);
            if (err.response) {
                if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                else if (err.response.status == 500) return { error: true, status: 500, message: 'Internal Server Error' };
            }
        }
    },
    async fetchOutputDocumentActivity({ commit }, transaction_id) {

        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(`${url}/output/activity/${transaction_id}`, {}, {
                headers: { 'x-drmms-token': authToken }
            });

            commit('setOutputDocumentActivity', response.data);
        } catch (err) {
            console.log(err);
            if (err.response) {
                if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                else if (err.response.status == 500) return { error: true, status: 500, message: 'Internal Server Error' };
            }
        }
    },
    async initiateDocumentRouteRequest({ commit }, body) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.post(`${url}/initiateRequest`, { documents: body }, {
                headers: { 'x-drmms-token': authToken }
            });

            commit('setDocumentInitiatePending', body);
        } catch (err) {
            console.log(err);
            if (err.response) {
                if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                else if (err.response.status == 500) return { error: true, status: 500, message: 'Internal Server Error' };
            }
        }
    },
    async fetchFilteredPendingDocuments({commit},payload){
        try {
            const categories = payload.category.length > 0 ? payload.category : []
            const types = payload.type.length > 0 ? payload.type : []
            const start_date =  moment(payload.dateRange.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss")
            const end_date =  moment(payload.dateRange.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss")      

            const query = {
                "$document.route_request_date$": {"$between": [start_date,end_date]},
                "$document.document_category_id$": {"$or": categories},
                "$document.document_type_id$": {"$or": types},
                "$document.is_initiated$": {"$is": false},
                "$document.pendingForInitiate$": {"$is": true},
            }
            const q = encodeURIComponent(JSON.stringify(query,null,4));
            const customUrl = url + '/initiate/pending?query='+ q ;
            
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(customUrl, {
                headers: { 'x-drmms-token': authToken }
            });
            commit('setPendingInitiateDocuments', response.data);
        }
        catch(err){
            commit('set_loading',false)
        }
    },
    async fetchPendingInitiateDocuments({ commit }, body) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(`${url}/initiate/pending`, {
                headers: { 'x-drmms-token': authToken }
            });

            commit('setPendingInitiateDocuments', response.data);
        } catch (err) {
            console.log(err);
            if (err.response) {
                if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                else if (err.response.status == 500) return { error: true, status: 500, message: 'Internal Server Error' };
            }
        }
    },
    async fetchRejectedDocuments({ commit }, body) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(`${url}/initiate/rejected`, {
                headers: { 'x-drmms-token': authToken }
            });
            commit('setRejectedDocuments', response.data);
        } catch (err) {
            console.log(err);
            if (err.response) {
                if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                else if (err.response.status == 500) return { error: true, status: 500, message: 'Internal Server Error' };
            }
        }
    },
    async uploadNewDocumentVersion({ commit }, body) {
        try {

            const authToken = localStorage.getItem('access_token');
            const response = await axios.post(`${url}/uploadNewVersion/${body.document_id}`, body, {
                headers: { 'x-drmms-token': authToken }
            });

            body.newInstance = response.data;

            commit('updateNewDocumentSource', body);
            return true;

        } catch (err) {
            console.log(err);
            if (err.response) {
                if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                else if (err.response.status == 500) return { error: true, status: 500, message: 'Internal Server Error' };
            }
        }
    },
    async removeInitiatedDocuments({ commit }, documents) {
        commit('deleteInitiatedDocuments', documents);
    },
    async fetchDocumentVersionHistory({ commit }, documentId) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(`${url}/version/history/${documentId}`, {}, {
                headers: { 'x-drmms-token': authToken }
            });

            const data = response.data.map(document => ({
                ...document,
                date_uploaded: moment(document.date_uploaded).format('LLL')
            }))

            commit('setDocumentVersionHistory', data);
        } catch (err) {
            console.log(err);
            if (err.response) {
                if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                else if (err.response.status == 500) return { error: true, status: 500, message: 'Internal Server Error' };
            }
        }
    },
    clearDocumentHistory({ commit}) {
        commit('setDocumentVersionHistory', []);
    }
};

const mutations = {
    addSupportingDocumentToArray: (state, body) => {
        var foundIndex = state.documents.findIndex(x => x.id == body[0].document_id);
        state.documents[foundIndex].supporting_documents = body
    },
    setDocuments: (state, documents) => {
        state.documents = documents.rows;
        state.documents_count = documents.count

    }, 
    updateDocument: (state, document) => {
        const index = state.documents.findIndex(docu => docu.id == document.id)
        if(index !== -1){
            state.documents.splice(index, 1, document)
        }
    },
    newDocument: (state, document) => state.documents.unshift(document),
    // removeAction: (state, id) => state.actions = state.actions.filter(action => action.id !== id),
    // updateAction: (state, updAction) => {
    //     const index = state.actions.findIndex(action => action.id === updAction.id);
    //     if(index !== -1) {
    //         state.actions.splice(index, 1, updAction);
    //     }
    // },
    setInitiatedDocuments: (state, documents) => (state.initiated_documents = documents),
    addInitDocumentsFromRoute: (state, ids) => {
        let newDocuments = [];
        let stateDocuments = state.documents;

        stateDocuments.forEach(element => {
            if (ids.includes(element.id)) {
                state.initiated_documents.unshift(element);
            } else {
                newDocuments.push(element);
            }
        });

        state.documents = newDocuments;
    },
    setOutputDocuments: (state, documents) => (state.output_documents = documents),
    setOutputDocumentActivity: (state, documents) => (state.output_activities = documents),
    setDocumentInitiatePending: (state, document) => {
        state.route_pending_documents.push(document);
        
		const index = state.documents.findIndex(d => d.id === document.id);
		if(index !== -1) {
			state.documents[index].pendingForInitiate = true;
		}
    },
    setPendingInitiateDocuments: (state, documents) => (state.route_pending_documents = documents),
    setRejectedDocuments: (state, documents) => (state.route_rejected_documents = documents),
    updateNewDocumentSource: (state, data) => {
        const { route_id, document_id, filepath_url } = data;

        if (!route_id) {
            let index = state.documents.findIndex(e => e.id === document_id);

            if (index !== -1) {
                if (state.documents[index].document_instances.length < 1) {
                    state.document_instances[index].document_instances = Object.assign(data.newInstance, { filepath_url: filepath_url })
                } else {
                    state.documents[index].document_instances[0].filepath_url = filepath_url;
                }

            }
        }
    },
    deleteInitiatedDocuments: (state, documents) => {
        let document_ids = [];
        documents.forEach(element => document_ids.push(element.id));

        let newSet = [];

        state.route_pending_documents.forEach(d => {
            if (!document_ids.includes(d.id)) {
                newSet.push(d);
            }
        });

        state.route_pending_documents = newSet;
    },
    setDocumentVersionHistory: (state, documents) => state.document_version_history = documents,
    set_loading: (state,load_value) => state.loading = load_value
};

export default {
    state,
    getters,
    actions,
    mutations,
}